import Vue from 'vue'
import VueRouter from 'vue-router'
import { IsPC, startTime, endTime } from '@/utils/util'
Vue.use(VueRouter)

// 解决vue-router重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 每次进入路由时重新判断 UA，避免 Vue Router 缓存首次解析的 PC 组件
const createAdaptiveView = (pcLoader, mLoader) => ({
  name: 'AdaptiveRouteView',
  data() {
    return {
      asyncComponent: null
    }
  },
  async created() {
    const load = IsPC() ? pcLoader : mLoader
    const module = await load()
    this.asyncComponent = module.default
  },
  render(h) {
    if (!this.asyncComponent) {
      return h('div')
    }
    return h(this.asyncComponent)
  }
})

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/noStart',
    name: 'NoStart',
    component: createAdaptiveView(
      () => import('../views/pc/noStart.vue'),
      () => import('../views/m/noStart.vue')
    )
  },
  {
    path: '/noEnd',
    name: 'NoEnd',
    component: createAdaptiveView(
      () => import('../views/pc/noEnd.vue'),
      () => import('../views/m/noEnd.vue')
    )
  },
  {
    path: '/index',
    name: 'Home',
    component: createAdaptiveView(
      () => import('../views/pc/home_pc.vue'),
      () => import('../views/m/home_m.vue')
    ),
    children: [
      {
        path: '',
        alias: ['/', '/index'],
        name: 'Index',
        component: createAdaptiveView(
          () => import('../views/pc/index.vue'),
          () => import('../views/m/index.vue')
        )
      },
      {
        path: '/answer',
        name: 'Answer',
        component: createAdaptiveView(
          () => import('../views/pc/answer.vue'),
          () => import('../views/m/answer.vue')
        )
      },
      {
        path: '/answerRecord',
        name: 'AnswerRecord',
        component: createAdaptiveView(
          () => import('../views/pc/answerRecord.vue'),
          () => import('../views/m/answerRecord.vue')
        )
      },
    ]
  }
];

const router = new VueRouter({
  routes,
})

router.beforeEach(async(to, from, next) => {
  const startT = new Date(startTime).getTime();
  const endT = new Date(endTime).getTime();
  const nowT = new Date().getTime();

  if (to.name === 'NoStart' || to.name === 'NoEnd') {
    next();
    return;
  }

  if (nowT <= startT) {
    next({ path: '/noStart' });
    return;
  }

  if (nowT > endT) {
    next({ path: '/noEnd' });
    return;
  }

  next();
})
export default router
